// removed by extract-text-webpack-plugin
module.exports = {"all-categories":"all-categories","left-content":"left-content","category-menu":"category-menu","title-category":"title-category","category-menu-item":"category-menu-item","item":"item","item-link":"item-link","category-sub-menu":"category-sub-menu","right-content":"right-content"};


//////////////////
// WEBPACK FOOTER
// ./components/category/_CategoryContainer.scss
// module id = ./components/category/_CategoryContainer.scss
// module chunks = 0